module.exports = __webpack_public_path__ + "static/media/tamara.b3f6a465.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wizard/contact/tamara.png
// module id = 1487
// module chunks = 0